import { rtkApi, GET_TEACHER_INTAKES } from '@/shared/api';
import { SuccessApiResponse } from '@/shared/types/common';
import { ITeacherIntakesRequest, ITeacherIntakesResponse } from './types';

const teacherIntakesApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getTeacherIntakes: build.query<ITeacherIntakesResponse, ITeacherIntakesRequest>({
      query: ({ courseId, ...params }) => ({
        url: `/teacher/courses/${courseId}/intakes`,
        params,
      }),
      transformResponse: (response: SuccessApiResponse<ITeacherIntakesResponse>) => response.data,
      providesTags: [GET_TEACHER_INTAKES],
    }),
  }),
});

export const { useGetTeacherIntakesQuery } = teacherIntakesApi;
